import { ErrorType } from "../../model/face.model";

export class setDefaultFace {
  static readonly type = "[Face] set default Face state";
  constructor() { }
}
export class getFaceImage {
  static readonly type = "[Face] get face image";
}
export class requestFaceImageQuality {
  static readonly type = "[Face] get face image quality";
  constructor(public payload: any) { }
}
export class getFaceMatchResult {
  static readonly type = "[Face] get face match result";
  constructor(public payload: any) { }
}
export class setFaceMatchResult {
  static readonly type = "[Face] set face match result";
  constructor(public payload: any) { }
}
export class setMatchLoading {
  static readonly type = "[Face] set face match loading";
  constructor(public payload: any) { }
}
export class setMatchLoaded {
  static readonly type = "[Face] set face match loaded";
  constructor(public payload: any) { }
}
export class isCameraOpen {
  static readonly type = "[Camera] is camera opened";
  constructor(public payload: boolean) { }
}
export class setCameraError {
  static readonly type = "[Camera] set camera error";
  constructor(public payload: { isError: boolean, errorType: any }) { }
}
export class setPadDisplay {
  static readonly type = "[Face] set PAD display";
  constructor(public payload: boolean) { }
}
export class setIdImageLoad {
  static readonly type = "[Face] set id document load";
  constructor(public payload: boolean) { }
}
export class setFaceImageLoad {
  static readonly type = "[Face] set face image load";
  constructor(public payload: boolean) { }
}
export class faceTimeOut {
  static readonly type = "[Face] set time out";
  constructor(public payload: boolean) { }
}
